(ns app.date-common)

(defprotocol ComparableDate
  (-before? [this another]
    "Return true if this date object is before another"))

(defprotocol AdjustableDate
  (-add-days [this days]
    "Produce a new date object with days added")
  (-subtract-days [this days]
    "Produce a new date object with days removed"))

(defn is-before?
  [start end]
  (-before? start end))

(defn is-equal?
  [start end]
  (and (not (-before? start end))
       (not (-before? end start))))

(defn is-after?
  [start end]
  (and (is-before? end start)
       (not (is-equal? start end))))

(defn make-incrementing-seq
  [start]
  (lazy-seq (cons start (make-incrementing-seq (-add-days start 1)))))

(defn make-decrementing-seq
  [start]
  (lazy-seq (cons start (make-decrementing-seq (-subtract-days start 1)))))

(defn date-seq-impl
  ([start]
   (make-incrementing-seq start))
  ([start end]
   (cond
     (is-equal? start end)
     []

     (is-before? end start)
     (->> (make-decrementing-seq start)
          (take-while (fn [day] (is-after? day end))))

     :else
     (->> (make-incrementing-seq start)
          (take-while (fn [day] (is-before? day end)))))))
